import DetailProfile from '../screens/user/DetailProfile'
import ChangePassword from '../screens/login/ChangePassword'
import React, { useContext, useEffect, useLayoutEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import InternalLayout from '../components/layouts/InternalLayout'
import PatientInternalLayout from '../patients/components/layouts/PatientInternalLayout'
import Login from '../screens/login/Login'
import PatientLogin from '../patients/screens/login/Login'
import PrivateRoute from "./PrivateRoute"
import PrivatePatientRoute from '../patients/routes/PrivatePatientRoute'
import { Navigate } from 'react-router-dom';
import MonitoryTutorials from '../patients/screens/tutorials/MonitoryTutorials'
import ExercisesTutorials from '../patients/screens/tutorials/ExercisesTutorials'
import MonitoryAndExerciseRoom from '../patients/screens/monitory-exercise-room/MonitoryAndExerciseRoom'

import ListDentist from '../screens/dentist/ListDentist'
import DetailDentist from '../screens/dentist/DetailDentist'
import CreateDentist from '../screens/dentist/CreateDentist'

import ListPatient from '../screens/patient/ListPatient'
import DetailPatient from '../screens/patient/DetailPatient'
import ListMonitor from '../screens/monitor/ListMonitor'
import ListControl from '../screens/control/ListControlOld'
import ListExerciselNew from '../screens/control/ListExerciselNew'
import ListControlNew from '../screens/control/ListControlNew'
import MonitoryRoom from '../screens/control/MonitoryRoom'
import ExerciseRoom from '../screens/control/ExerciseRoom '
import ListHolidays from '../screens/holidays/ListHolidays'
import Dashboard from '../screens/dentist/Dashboard'
import ListProtocol from '../screens/protocol/ListProtocol'
import ProtocolDetail from '../screens/protocol/ProtocolDetail'

import AdministratorDashboard from '../screens/administrator_dashboard/AdministratorDashboard'


import { ResetPassword } from '../screens/user/ResetPassword'
import axios from 'axios'
import GeneralContext from '../context/GeneralContext/GeneralContext'
import ListStatusHistory from '../screens/statusHistory/ListStatusHistory'
import PermissionedRoute from './PermissionedRoute'

import EUsersTypes from '../enums/EUsersTypes' 
import Home from '../patients/screens/Home'
import { Config } from '../screens/config-rules/Config'
import { getLanguageOnLocalstorage } from '../services/helper'
import ListExercise from '../screens/exercise/ListExercise'
import ListPatientProtocol from '../screens/patient-protocol/ListPatientProtocol'

// import { Sortie } from '../screens/SortiePatientsDentists'

function Router() {

  const {
    setShowLoading,
    user
  } = useContext(GeneralContext)

  useEffect(() => {
    axios.interceptors.response.use(
      function (rs) {
        return rs
      },
      function (err) {
        setShowLoading(false)

        if (err?.response?.data?.redirect_to_login) {
          localStorage.removeItem("user")
          localStorage.removeItem('token')
        } else if (err?.response?.data?.error) {
          alert(err?.response?.data?.error, 'error')
        }
        return Promise.reject(err)
      }
    )
    axios.interceptors.request.use(function (config) {
      config.headers['x-language'] = getLanguageOnLocalstorage()
      return config
    })
  }, [])


  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="changePassword"
          element={
            <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ChangePassword /></PermissionedRoute>
          }
        />
        <Route path='/' element={<PrivateRoute />}>
          <Route element={<InternalLayout />}>
            <Route
              index
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListPatient /></PermissionedRoute>
              }
            />
            <Route
              path="patient/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListPatient /></PermissionedRoute>
              }
            />
               { <Route
              path="protocol"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListProtocol /></PermissionedRoute>
              }
            /> }
            { <Route
              path="exercise/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListExercise /></PermissionedRoute>
              }
            /> }

            <Route
              path="dentist/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListDentist /></PermissionedRoute>
              }
            />

            
            <Route 
              path="dashboard/administrator"
              element={ <PermissionedRoute permissions={[EUsersTypes.ADMIN.code]}><AdministratorDashboard /></PermissionedRoute> }
            />
            <Route 
              path="patient-protocol"
              element={     <PermissionedRoute permissions={[EUsersTypes.ADMIN.code, EUsersTypes.DENTIST.code]}>
              <ListPatientProtocol />
            </PermissionedRoute> }
            />
            <Route
              path="/status-history/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListStatusHistory /></PermissionedRoute>
              }
            />

            <Route
              path="monitor/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListMonitor /></PermissionedRoute>
              }
            />

            <Route
              path="control_old/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListControl /></PermissionedRoute>
              }
            />

            {/* <Route
              path="exercise_control/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListExerciselNew /></PermissionedRoute>
              }
            /> */}

            <Route
              path="control/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListControlNew /></PermissionedRoute>
              }
            />

            <Route
              path="reset-password"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ResetPassword /></PermissionedRoute>
              }
            />

            {/* <Route
              path="/add-dentists-and-patients"
              element={
                <Sortie />
              }
            /> */}


            <Route
              path="monitory-room"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><MonitoryRoom /></PermissionedRoute>
              }
            />

            <Route
              path="exercise-room"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ExerciseRoom /></PermissionedRoute>
              }
            />

            <Route
              path="holiday/list"
              element={
                <PermissionedRoute permissions={EUsersTypes.INTERNAL}><ListHolidays /></PermissionedRoute>
              }
            />
            <Route
              path="config"
              element={
                <PermissionedRoute permissions={[EUsersTypes.ADMIN.code]}><Config /></PermissionedRoute>
              }
            />

            <Route
              path={
                'dashboard'
              }
              element={user?.user_type === EUsersTypes.DENTIST.code ? <Dashboard /> : <Navigate to='/' />}
            />

            {/* <Route
              path={
                'protocol'
              }
              element={
                <PermissionedRoute permissions={[EUsersTypes.ADMIN.code]}><ListProtocol /></PermissionedRoute>
              }
            />
        */}
             <Route
              path={
                'protocol/detail'
              }
              element={
                <PermissionedRoute permissions={[EUsersTypes.ADMIN.code]}><ProtocolDetail /></PermissionedRoute>
              }
            />
            
          </Route>
        </Route>
        <Route
              path={
                'protocol/detail'
              }
              element={
                <PermissionedRoute permissions={[EUsersTypes.ADMIN.code]}><ProtocolDetail /></PermissionedRoute>
              }
            />
            
        <Route path='/patient-home' element={<PrivatePatientRoute />}>
          <Route element={<PatientInternalLayout />}>
            <Route
                index
                element={
                  <Home />
                }
            />
            <Route
              path="monitory-tutorials"
              element={
                <MonitoryTutorials />
              }
            />
            <Route
              path="exercises-tutorials"
              element={
                <ExercisesTutorials />
              }
            />
            <Route
              path="monitory"
              element={
                <MonitoryAndExerciseRoom is_exercise_room={false} />
              }
            />
            <Route
              path="exercise"
              element={
                <MonitoryAndExerciseRoom is_exercise_room={true} />
              }
            />
            </Route>
        </Route>
        <Route path="login" element={<Login />} />
        <Route path="login/patient" element={<PatientLogin />} />
        {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
      </Routes>
    </BrowserRouter>
  )
}

export default Router;
